module.exports = __webpack_public_path__ + "img/error-500.b53baf6d.png";